<template>
  <div id="loginForm" class="login">
    <div class="login-card row">
      <div class="login-card-logo col-md-7">
        <img v-img-fallback="{ loading: imgBaseUrl + 'pixel.png', error: imgBaseUrl + 'kerlink-light.png' }" :src="imgBaseUrl + 'logo/logo-light.png'" alt="Logo">

        <h4 class="mt-4 text-secondary text-center text-uppercase font-weight-bold">Wanesy Management Center</h4>
      </div>

      <div class="login-card-form col-md-5">
        <div class="form-group">
          <label class="control-label text-white" for="login">{{ $t('login:username') | capitalize }}</label>
          <input id="username"
                 v-model="username"
                 :placeholder="$t('login:username') | capitalize"
                 type="text"
                 class="form-control"
                 autocomplete="username"
                 @keyup.enter="login"
          >
        </div>

        <div class="form-group">
          <label class="control-label text-white" for="password">{{ $t('login:password') | capitalize }}</label>
          <input id="password"
                 v-model="password"
                 :placeholder="$t('login:password') | capitalize"
                 class="form-control"
                 type="password"
                 autocomplete="current-password"
                 @keyup.exact="checkCapslock"
                 @keyup.enter="login"
          >
        </div>

        <div v-show="isCapsLock" class="caps-lock">{{ $t('login:capsLock') | capitalize }}</div>
        <div v-show="error === 1" class="alert alert-danger" role="alert">{{ $t('login:blankLoginError') | capitalize }}</div>
        <div v-show="error === 2" class="alert alert-danger" role="alert">{{ $t('login:blankPwdError') | capitalize }}</div>
        <div v-show="error === 3" class="alert alert-danger" role="alert">{{ $t('login:blankLoginPwdError') | capitalize }}</div>
        <div v-show="error === 4" class="alert alert-danger" role="alert">{{ $t('login:badCredentialsError') | capitalize }}</div>
        <div v-show="error === 5" class="alert alert-danger" role="alert">{{ $t('login:expiredError', {user: username}) | capitalize }}</div>
        <div v-show="error === 6" class="alert alert-danger" role="alert">{{ $t('login:disabledError', {user: username}) | capitalize }}</div>
        <div v-show="error === 7" class="alert alert-danger" role="alert">{{ $t('login:noValidatedError', {user: username}) | capitalize }}</div>
        <div v-show="error === 0" class="alert alert-danger" role="alert">{{ $t('login:unknownError') | capitalize }}</div>

        <button id="loginButton" :disabled="isSigningIn" type="button" class="btn btn-secondary btn-block" @click="login">{{ isSigningIn ? $t('login:signingIn') : $t('login:signIn') | capitalize }}</button>

        <div class="forgot text-center">
          <router-link id="forgotPassword" to="/forgotPassword" class="text-white">{{ $t('login:forgot') | capitalize }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import to from '@/modules/await-to-js'

export default {
  titleKey: 'login',

  data () {
    return {
      username: '',
      password: '',
      isCapsLock: false,
      isSigningIn: false,
      error: null
    }
  },

  watch: {
    // Reset error when modifying username
    username () {
      this.error = null
    },
    // Reset error when modifying password
    password () {
      this.error = null
    }
  },

  methods: {
    // Call login API
    async login () {
      if (this.isSigningIn) return

      if (this.username && this.password) {
        // Reset error
        this.error = null
        // Deactivate button
        this.isSigningIn = true

        let error, response
        [error, response] = await to(this.$api.login(this.$store.getters.application, this.username, this.password))

        if (error || !response) {
          this.isSigningIn = false
          switch (error.response.data.code) {
            case 'SECURITY_BAD_CREDENTIALS':
              this.error = 4
              break
            case 'SECURITY_USER_EXPIRED':
              this.error = 5
              break
            case 'SECURITY_USER_DISABLED':
              this.error = 6
              break
            case 'SECURITY_USER_NOT_VALIDATED':
              this.error = 7
              break
            default:
              this.error = 0
          }
          return
        }

        this.$api.saveToken(response)
        this.isSigningIn = false
        this.error = response.status
        this.$router.push(this.$route.query.redirect || '/')
      } else {
        this.error = (this.username ? 0 : 1) + (this.password ? 0 : 2)
      }
    },

    // Check caps-lock status
    checkCapslock (event) {
      this.isCapsLock = event.getModifierState('CapsLock')
    }
  }
}
</script>
